module.exports = __webpack_public_path__ + "static/media/things-i-enjoy.68ff57e7.png";